import React from "react";
import { Pie } from "react-chartjs-2";
import styled from "styled-components";
import { capitalize, colors } from "../utils";

const Container = styled.div`
  height: auto;
  max-width: 35rem;
  margin: auto;
`;

const GenderChart = ({ data }) => {
  const labels = data.map(({ name }) => capitalize(name));

  return (
    <Container>
      <Pie
        data={{
          labels: data.map(
            ({ name, value }) => `${capitalize(name)} (${value})`
          ),
          datasets: [
            {
              data: data.map(({ value }) => value),
              backgroundColor: colors,
              hoverBackgroundColor: colors
            }
          ]
        }}
        options={{
          tooltips: {
            callbacks: {
              label: ({ index }, { datasets }) => {
                const [{ data }] = datasets;

                return `${labels[index]}: ${data[index]}`;
              }
            }
          }
        }}
      />
    </Container>
  );
};

export default GenderChart;
